import type { Release } from '../releases.ts';

export default {
  version: '0.17.1',
  date: '2026-10-02',
  title: 'Export and phone recorder fixes',
  summary: [
    'The phone recorder records at 25 fps by default, with 30 fps as a choice',
    'Fixed: sequences that mix cuts and transitions export again',
    'Fixed: photos on the storyline export as the photo instead of black',
    'Fixed: export errors name the first cause',
  ],
  features: [
    'The phone recorder records at 25 fps by default, with 30 fps as a choice; it shows the rate the camera actually delivers',
  ],
  fixes: [
    'Exporting a sequence that mixes cuts and transitions no longer fails with “Nothing was written into output file”',
    'Photos placed on the storyline are exported as the photo instead of black',
    'When FFmpeg fails, the export error names the first cause rather than only its consequence',
  ],
} satisfies Release;
